export default __webpack_public_path__ + "static/media/price-low-active.275dd844.svg";